
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceforcorporateevents() {



    const cardData =
    {
        keyword: 'Corporate Cab Services for Corporate Events in Mumbai  ',
        heading: 'etravo : Corporate Cab Services for Corporate Events in Mumbai',



"headingDescription": "eTravo offers reliable Corporate Cab Services for Corporate Events in Mumbai, designed to manage seamless transportation for conferences, meetings, exhibitions, and corporate gatherings. With a fleet of sedans, SUVs, luxury cars, and buses along with professional chauffeurs, eTravo ensures smooth guest movement, airport transfers, and event logistics. Flexible and scalable solutions make it an ideal partner for corporate event transportation across Mumbai.",

"top": "Top Corporate Event Locations in Mumbai with eTravo",

"topPlaces": [
  {
    "title": "Bandra Kurla Complex (BKC)",
    "description": "Mumbai’s top financial and corporate hub, hosting major conferences, business events, and exhibitions requiring large-scale transport coordination."
  },
  {
    "title": "Jio World Convention Centre",
    "description": "A premier venue for corporate events, expos, and summits where organized cab services are essential for guest and executive movement."
  },
  {
    "title": "Nehru Centre, Worli",
    "description": "A well-known venue for corporate exhibitions and seminars, requiring efficient transportation for attendees and speakers."
  },
  {
    "title": "Andheri East (SEEPZ & MIDC)",
    "description": "A major corporate and IT zone hosting business events and meetings, requiring reliable employee and guest transport services."
  },
  {
    "title": "Powai Business District",
    "description": "A key hub for corporate offices and tech companies where offsites, meetings, and events require structured cab services."
  },
  {
    "title": "Lower Parel Corporate Zone",
    "description": "A modern business district with corporate towers and event venues requiring executive travel and guest transport solutions."
  },
  {
    "title": "Goregaon Exhibition Centre (NESCO)",
    "description": "A major venue for trade shows and corporate exhibitions, demanding large-scale transport logistics for attendees."
  },
  {
    "title": "Nariman Point",
    "description": "A traditional business district hosting corporate meetings and high-level executive events requiring premium cab services."
  },
  {
    "title": "Mumbai Airport (T1 & T2)",
    "description": "A critical zone for corporate event travel, managing VIP pickups, guest arrivals, and executive airport transfers."
  },
  {
    "title": "Thane Corporate Zone",
    "description": "A growing business hub hosting corporate gatherings and events requiring dependable transportation services."
  }
],


"services": [
{
"name": "Event Cab Service Mumbai",
"description": "eTravo offers reliable event cab services in Mumbai for smooth and hassle-free transportation. Whether it’s corporate events, private functions, or large gatherings, our service ensures punctual pickups and comfortable travel for all attendees."
},
{
"name": "Corporate Event Taxi Mumbai",
"description": "Our corporate event taxi services in Mumbai are designed for business functions and official gatherings. eTravo ensures professional drivers, clean vehicles, and timely service for executives and teams."
},
{
"name": "Event Transport Mumbai",
"description": "eTravo provides complete event transport services in Mumbai for corporate and private events. Our service ensures efficient coordination, reliable vehicles, and smooth travel arrangements for guests and staff."
},
{
"name": "Corporate Event Cab Hire Mumbai",
"description": "Choose eTravo’s corporate event cab hire in Mumbai for dependable group transportation. Our service ensures seamless travel for conferences, meetings, and corporate events with well-managed logistics."
},
{
"name": "Business Event Cab Mumbai",
"description": "eTravo’s business event cab services in Mumbai are ideal for professional gatherings and corporate meetings. We ensure punctual service, comfortable rides, and efficient travel coordination."
},
{
"name": "Company Event Transport Mumbai",
"description": "eTravo offers company event transport services in Mumbai tailored for corporate needs. Our service ensures smooth movement of employees and guests for business events and functions."
},
{
"name": "Corporate Travel Events Mumbai",
"description": "Our corporate travel services for events in Mumbai provide seamless transportation solutions. eTravo ensures reliable travel arrangements for conferences, seminars, and corporate functions."
},
{
"name": "Event Pickup Drop Mumbai",
"description": "eTravo provides event pickup and drop services in Mumbai for convenient guest transportation. Our service ensures timely arrivals and departures with smooth coordination."
},
{
"name": "Corporate Function Cab Mumbai",
"description": "eTravo offers corporate function cab services in Mumbai for meetings, seminars, and official gatherings. Our service ensures comfortable travel and professional service for attendees."
},
{
"name": "Staff Event Transport Mumbai",
"description": "Our staff event transport services in Mumbai are designed for smooth employee movement during corporate events. eTravo ensures safe, timely, and well-organized travel."
},
{
"name": "Corporate Event Taxi Booking Mumbai",
"description": "eTravo makes corporate event taxi booking in Mumbai simple and efficient. Our service ensures reliable vehicles, easy booking, and smooth transportation for events."
},
{
"name": "Business Function Cab Mumbai",
"description": "eTravo’s business function cab services in Mumbai provide reliable travel for corporate gatherings. Our service ensures punctual pickups and comfortable rides for professionals."
},
{
"name": "Office Event Transport Mumbai",
"description": "eTravo offers office event transport services in Mumbai for company events and team outings. Our service ensures efficient travel coordination and comfortable journeys."
},
{
"name": "Event Cab Booking Mumbai",
"description": "Book event cabs in Mumbai easily with eTravo. Our service ensures timely pickups, reliable vehicles, and hassle-free travel for all types of events."
},
{
"name": "Corporate Gathering Cab Mumbai",
"description": "eTravo provides corporate gathering cab services in Mumbai for smooth and organized transportation. Our service ensures comfortable travel for employees and guests attending business events."
}
],
"tableData": [
["Event Cab Service Mumbai", "Corporate Event Taxi Mumbai"],
["Event Transport Mumbai", "Corporate Event Cab Hire Mumbai"],
["Business Event Cab Mumbai", "Company Event Transport Mumbai"],
["Corporate Travel Events Mumbai", "Event Pickup Drop Mumbai"],
["Corporate Function Cab Mumbai", "Staff Event Transport Mumbai"],
["Corporate Event Taxi Booking Mumbai", "Business Function Cab Mumbai"],
["Office Event Transport Mumbai", "Event Cab Booking Mumbai"],
["Corporate Gathering Cab Mumbai", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Premium Corporate Cab Services for Corporate Events in Mumbai",
      "WhyChoosedescription": "eTravo offers professional corporate cab services for corporate events in Mumbai, ensuring seamless transportation for conferences, seminars, exhibitions, and business gatherings."
    },
    {
      "WhyChooseheading": "Ideal for Conferences, Meetings, and Business Events",
      "WhyChoosedescription": "Our services are tailored for corporate events including client meetings, product launches, seminars, and corporate functions across Mumbai’s key venues."
    },
    {
      "WhyChooseheading": "Efficient Group Transportation Management",
      "WhyChoosedescription": "We provide organized transport solutions for large groups, ensuring smooth coordination for employee movement, guest transfers, and event logistics."
    },
    {
      "WhyChooseheading": "Wide Fleet for Every Event Requirement",
      "WhyChoosedescription": "Our fleet includes sedans, SUVs, luxury cars, and larger vehicles suitable for VIP guests, executives, and employee transport during corporate events."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Event Experience",
      "WhyChoosedescription": "Our drivers are trained in handling corporate events, ensuring punctual, polite, and professional service for executives and guests."
    },
    {
      "WhyChooseheading": "Flexible Booking for Event Schedules",
      "WhyChoosedescription": "We offer hourly, full-day, and multi-day booking options, allowing companies to manage transportation efficiently throughout the event duration."
    },
    {
      "WhyChooseheading": "Reliable and Time-Sensitive Service",
      "WhyChoosedescription": "With precise scheduling and coordination, we ensure timely pickups and drop-offs, avoiding delays during important corporate events."
    },
    {
      "WhyChooseheading": "24/7 Support for Event Transportation",
      "WhyChoosedescription": "Our support team is available round the clock to manage last-minute changes, guest requirements, and smooth execution of corporate event travel."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services for corporate events in Mumbai?',
            answer: 'These services provide organized transportation for corporate events including conferences, meetings, exhibitions, and business gatherings.',
        },
        {
            question: 'What types of events require corporate cab services?',
            answer: 'Events like seminars, conferences, product launches, exhibitions, corporate meetings, and employee gatherings require transportation services.',
        },
        {
            question: 'Can I book cabs for large corporate groups?',
            answer: 'Yes, providers offer group transportation solutions with multiple vehicles and coordinated scheduling.',
        },
        {
            question: 'What types of vehicles are available for corporate events?',
            answer: 'Vehicles include sedans, SUVs, luxury cars, and larger vehicles depending on the number of attendees and event requirements.',
        },
        {
            question: 'Are chauffeurs trained for corporate event travel?',
            answer: 'Yes, drivers are trained to handle corporate guests with professionalism and punctuality.',
        },
        {
            question: 'Can transportation be customized for event schedules?',
            answer: 'Yes, services can be customized with flexible timings and routes based on the event plan.',
        },
        {
            question: 'Are corporate cab services available for multi-day events?',
            answer: 'Yes, you can book vehicles for single-day or multi-day corporate events.',
        },
        {
            question: 'Is airport transfer included for corporate event guests?',
            answer: 'Yes, airport pickup and drop services can be arranged for guests and executives attending the event.',
        },
        {
            question: 'Are services available 24/7 for corporate events?',
            answer: 'Yes, corporate cab services operate round the clock to support event schedules.',
        },
        {
            question: 'How can I book corporate cab services for events in Mumbai?',
            answer: 'You can book online or contact the support team for customized corporate event transportation solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Karan Shah',
        designation: 'Event Manager, Corporate Firm, Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo handled transportation for our corporate event in Mumbai flawlessly. Their coordination and punctuality were excellent.”',
    },
    {
        name: 'Ms. Riya Mehta',
        designation: 'HR Head, MNC, Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked cabs for a corporate seminar, and eTravo delivered outstanding service. Their professional drivers ensured a smooth experience for all attendees.”',
    },
];





    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services for Corporate Events in Mumbai",
  "image": "https://www.etravo.in/images/keyword/corporate-event-cab-mumbai.jpg",
  "description": "Reliable corporate cab services for events in Mumbai by eTravo. Ideal for business events, corporate functions, employee group transport, event pickup and drop, and professional event travel solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-for-corporate-events-in-mumbai"
  }
};



    return (
        <div>


<Helmet>
  <title>Corporate Cab Services for Events in Mumbai | Business & Event Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services for events in Mumbai with eTravo. Perfect for business events, corporate functions, staff transport, and event pickup and drop services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/143.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceforcorporateevents;